<script setup lang="ts">
import { useAppStore, useWalletStore, useDexStore } from '@/store'
import { beeAuth, queryBeeUserInfo, heartCheck } from './api/dex'
import Cookies from 'js-cookie'
import { DEX_ROUTES } from './constants'

const walletTimer = ref<any>(null)
const chainTimer = ref<any>(null)
const checkTimer = ref<any>(null)
const appStore = useAppStore()
const walletStore = useWalletStore()
const dexStore = useDexStore()
const route = useRoute()

const appDirection = computed(() => appStore.direction)

/**
 * 轮训钱包接口
 */
const queryWallet = async () => {
  try {
    if (walletTimer.value) {
      clearTimeout(walletTimer.value)
    }
    await walletStore.queryWalletInfo()
    walletTimer.value = setTimeout(() => {
      queryWallet()
    }, 3000)
  } catch (e: any) {
    console.log('e', e)
    if (walletTimer.value) {
      clearTimeout(walletTimer.value)
    }
  }
}

/**
 * 轮训多链接口
 */
const queryChains = async () => {
  try {
    if (chainTimer.value) {
      clearTimeout(chainTimer.value)
    }
    await dexStore.queryChains()
    chainTimer.value = setTimeout(() => {
      queryChains()
    }, 10000)
  } catch (e) {
    console.log('e', e)
    if (chainTimer.value) {
      clearTimeout(chainTimer.value)
    }
  }
}

/**
 * bee查询用户信息
 */
const beeQueryUserInfo = async () => {
  try {
    const { data } = await queryBeeUserInfo()
    sessionStorage.setItem('beeUserInfo', JSON.stringify(data))
  } catch (e) {
    console.log('beeQueryUserInfo', e)
  }
}

const walletCheck = async () => {
  try {
    await heartCheck()
    checkTimer.value = setTimeout(() => {
      walletCheck()
    }, 2000)
  } catch (e) {
    console.log('walletCheck', e)
  }
}

const dexQuery = () => {
  try {
    clearTimer()
    dexStore.getUserInfo()
    queryWallet()
    queryChains()
    dexStore.queryDexConfig()
    walletCheck()
  } catch (e) {
    console.log('登录', e)
  }
}

const init = async () => {
  if (route.query?.accessToken) {
    const accessToken = (route.query.accessToken as string)?.replace?.(
      /\s+/g,
      '+',
    )
    try {
      const {
        data: { token },
      } = await beeAuth({
        accessToken: accessToken,
      })
      Cookies.set('token', token)
      beeQueryUserInfo()
    } catch (e) {
      console.log('beeAuth', e)
    }
  }
  dexQuery()
}

const clearTimer = () => {
  if (chainTimer.value) {
    clearTimeout(chainTimer.value)
  }
  if (walletTimer.value) {
    clearTimeout(walletTimer.value)
  }
  if (checkTimer.value) {
    clearTimeout(checkTimer.value)
  }
}

const handleVisibilityShow = () => {
  if (document.visibilityState === 'visible') {
    init()
  } else {
    clearTimer()
  }
}

watch(
  route,
  (r) => {
    if (r && r?.name) {
      if (DEX_ROUTES.includes(r.name as string)) {
        dexQuery()
      } else {
        clearTimer()
      }
    }
  },
  { immediate: true },
)

onMounted(() => {
  document.addEventListener('visibilitychange', handleVisibilityShow)
})

onUnmounted(() => {
  clearTimer()
  document.removeEventListener('visibilitychange', handleVisibilityShow)
})
</script>

<template>
  <div :dir="appDirection">
    <n-dialog-provider>
      <n-modal-provider>
        <n-message-provider>
          <RouterView />
        </n-message-provider>
      </n-modal-provider>
    </n-dialog-provider>
  </div>
</template>

<style scoped></style>
